// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2RhMa","colMaxWidth":"Table_colMaxWidth__1mBB9"};